import type { RequestApplication } from "./certificate.types";
import { rtkqApi } from "../api/rtkqApi";

export const certificateApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    addCertificateApplication: build.mutation<void, RequestApplication>({
      query({ name, phone, email, company, comment }) {
        return {
          url: "/foundation/api/corporate/certificate/application",
          method: "POST",
          body: {
            name,
            phone,
            email,
            company,
            comment,
          },
        };
      },
    }),
  }),
});
